// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"_1wI0O","imageLink":"_1AbSv","image":"_2Z2ro"};